<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { http, setToken, setUser, takeIntent } from '../composables/http'
import useRouter from '../composables/useRouter'

const email = ref('one@example.com')
const password = ref('123456')
const message = ref('')
useRouter()

onMounted(async () => {
  const src = 'https://accounts.google.com/gsi/client'
  if (document.querySelector(`head script[src="${src}"`)) return
  const tag = document.createElement('script')
  tag.setAttribute('src', src)
  tag.setAttribute('async', '')
  tag.setAttribute('type', 'text/javascript')
  document.head.append(tag)
  document.getElementById('g_id_onload').setAttribute('data-client_id', window.beteConfig.googleOAuthClientId)
})

function handleLoginResponse(resp: any) {
  if (resp.error) {
    message.value = resp.error || 'Informe usuário e senha!'
  } else {
    const data = resp.data
    setToken(data['token'])
    setUser({ id: data['user_id'], admin: data['admin']})
    const router = useRouter()
    // De volta para onde a pessoa estava indo. Sem isso, o deep link que a Bete manda no Google
    // Chat morre aqui: o login mandava todo mundo para `/analyze`, sem telefone e sem a acao.
    router.push(takeIntent() || '/analyze')
  }
}

function login() {
  message.value = ''
  http('/login', {
    method: 'POST',
    body: JSON.stringify({
      email_address: email.value,
      password: password.value
    })
  }).then(handleLoginResponse)
}

window.handleCredentialResponse = function(data: any) {
  const token = data.credential;
  http('/auth/google/callback', {
    method: 'POST',
    body: JSON.stringify({ token })
  }).then(handleLoginResponse)
}
</script>

<template>
  <div class="flex items-center justify-center h-screen px-6 bg-gray-200">
    <div class="w-full max-w-sm p-6 bg-white rounded-md shadow-md">
      <div class="flex items-center justify-center">
        <span class="text-2xl font-semibold text-gray-700">Bete</span>
      </div>

      <div v-if="message" class="flex items-center justify-between mt-4">
        {{ message }}
      </div>

      <form class="mt-4" @submit.prevent="login">
        <label class="block">
          <span class="text-sm text-gray-700">Email</span>
          <input
            v-model="email"
            type="email"
            class="block w-full mt-1 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
          >
        </label>

        <label class="block mt-3">
          <span class="text-sm text-gray-700">Senha</span>
          <input
            v-model="password"
            type="password"
            class="block w-full mt-1 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
          >
        </label>
        <div class="mt-6">
          <button
            type="submit"
            class="w-full px-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500"
          >
            Entrar
          </button>
        </div>
      </form>

      <div id="g_id_onload" data-client_id="" data-callback="handleCredentialResponse" />
      <div class="g_id_signin" data-type="standard" />
    </div>
  </div>
</template>
